var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleGraphicFive1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 263,
    height: 263,
    viewBox: "0 0 263 263",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M131.1 261.2C202.952 261.2 261.2 202.952 261.2 131.1C261.2 59.2478 202.952 1 131.1 1C59.2478 1 1 59.2478 1 131.1C1 202.952 59.2478 261.2 131.1 261.2Z",
    stroke: "#8D46D1",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M131.1 242.23C192.475 242.23 242.23 192.475 242.23 131.1C242.23 69.7246 192.475 19.97 131.1 19.97C69.7246 19.97 19.97 69.7246 19.97 131.1C19.97 192.475 69.7246 242.23 131.1 242.23Z",
    fill: "url(#paint0_radial_46_108)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_46_108",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(131.1 131.1) scale(111.13 111.13)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D46D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#8D46D1",
    stopOpacity: 0.9801
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#8D46D1",
    stopOpacity: 0.8836
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#8D46D1",
    stopOpacity: 0.7396
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#8D46D1",
    stopOpacity: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#8D46D1",
    stopOpacity: 0.3721
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#8D46D1",
    stopOpacity: 0.1849
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#8D46D1",
    stopOpacity: 0.0529
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D46D1",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleGraphicFive1);
export default __webpack_public_path__ + "static/media/circle-graphic-five-1.ea695678df8cfaa9cfb22c5342a20c84.svg";
export { ForwardRef as ReactComponent };